import client from './client';

export interface GongdaoRecord {
  id: string;
  type: string;
  timestamp: number;
  amount: number;
  direction: 'income' | 'expense';
}

export interface GetHistoryResponse {
  total: number;
  list: GongdaoRecord[];
}

export const getGongdaoHistory = async (page: number = 1, pageSize: number = 20): Promise<GetHistoryResponse> => {
  const response = await client.get('/user/gongdao-history', {
    params: {
      page,
      pageSize,
    },
  });
  return response.data.data;
};
